import { useEffect, useRef, useState, useLayoutEffect } from "react";
import { coreFieldStyles, DynamicSelectorButtons, Field, Input, Textarea } from "../../../components/forms";
import { ButtonLight } from "../../../components/ctas";
import { useAppContext } from "../../../contexts/app";
import { FieldsetWrapperFS, makeValues, QCSubNav } from "../unit/page";
import { digitsOnly, formatDate, formatPhoneNumber, removeSpecialCharacters } from "../../../utils/formatting";
import { UseGoogleSheet } from "../../../hooks/UseGoogleSheets";
import { generateUUID } from "../../../utils/global";
import { useParams } from "react-router-dom";
import { useAuth } from "../../../hooks/useAuth";
import { useNavigate } from "react-router-dom";
import { removeUnderscore } from "../../dashboard/qc/page";
import { CheckBox } from "../qc/page";

export const customerFormData = [
	// { name: "Business Name", description: "Name of purchasing/leasing business" },
	// { name: "Primary Email", description: "Customer's primary email", type: "email" },
	// { name: "Primary Phone", description: "Customer's primary phone number", filter: "phone", type: "tel", max: "14" },
	// { name: "Customer Name", description: "Name of purchasing/leading customer" },
	// { name: "Customer Address", description: "Name of purchasing/leading customer", type: "textarea" },
	// { name: "Tax Exempt", description: "Customer is tax exempt", type: "checkbox" },

	{ name: "Customer Name", description: "Select Customer", type: "customer-select" },

	{},

	{ name: "Alpha", description: "Quantity of Alphas", type: "tel" },
	{ name: "Alpha Custom Price", description: "Override Price of Alphas", type: "tel" },

	{},

	{ name: "Alpha SIGHT", description: "Quantity of Alpha SIGHTs", type: "tel" },
	{ name: "Alpha SIGHT Custom Price", description: "Override Price of Alpha SIGHTs", type: "tel" },

	{},

	{ name: "Alpha APEX", description: "Quantity of Alphas APEXs", type: "tel" },
	{ name: "Alpha APEX Custom Price", description: "Override Price of Alpha APEXs", type: "tel" },

	{},
	// { name: "Alpha FLIGHT", description: "Quantity of Alphas FLIGHTs", type: "tel" },
	{ name: "Bravo", description: "Quantity of Bravo", type: "tel" },
	{ name: "Bravo Custom Price", description: "Override Price of Bravos", type: "tel" },

	{},

	{ name: "Pogo", description: "Quantity of Pogos", type: "tel" },
	{ name: "Pogo Custom Price", description: "Override Price of Pogos", type: "tel" },

	{},

	{ name: "Custom Input Name", description: "Name of the custom input", type: "text" },
	{ name: "Custom Input Description", description: "Description of the custom input", type: "text" },
	{ name: "Custom Input Cost", description: "Cost of the custom input", type: "tel" },
	{ name: "Custom Input Custom Price", description: "Override Price of the custom input", type: "tel" },
	{ name: "Custom Input Quantity", description: "Quantity of the custom input", type: "tel" },

	{ name: "Custom Input 2 Name", description: "Name of the custom input 2", type: "text" },
	{ name: "Custom Input 2 Description", description: "Description of the custom input 2", type: "text" },
	{ name: "Custom Input 2 Cost", description: "Cost of the custom input 2", type: "tel" },
	{ name: "Custom Input 2 Custom Price", description: "Override Price of the custom input 2", type: "tel" },
	{ name: "Custom Input 2 Quantity", description: "Quantity of the custom input 2", type: "tel" },

	{ name: "Custom Input 3 Name", description: "Name of the custom input 3", type: "text" },
	{ name: "Custom Input 3 Description", description: "Description of the custom input 3", type: "text" },
	{ name: "Custom Input 3 Cost", description: "Cost of the custom input 3", type: "tel" },
	{ name: "Custom Input 3 Custom Price", description: "Override Price of the custom input 3", type: "tel" },
	{ name: "Custom Input 3 Quantity", description: "Quantity of the custom input 3", type: "tel" },

	{ name: "Custom Input 4 Name", description: "Name of the custom input 4", type: "text" },
	{ name: "Custom Input 4 Description", description: "Description of the custom input 4", type: "text" },
	{ name: "Custom Input 4 Cost", description: "Cost of the custom input 4", type: "tel" },
	{ name: "Custom Input 4 Custom Price", description: "Override Price of the custom input 4", type: "tel" },
	{ name: "Custom Input 4 Quantity", description: "Quantity of the custom input 4", type: "tel" },

	{ name: "Custom Input 5 Name", description: "Name of the custom input 5", type: "text" },
	{ name: "Custom Input 5 Description", description: "Description of the custom input 5", type: "text" },
	{ name: "Custom Input 5 Cost", description: "Cost of the custom input 5", type: "tel" },
	{ name: "Custom Input 5 Custom Price", description: "Override Price of the custom input 5", type: "tel" },
	{ name: "Custom Input 5 Quantity", description: "Quantity of the custom input 5", type: "tel" },

	{},

	{ name: "Memo", description: "Memo for the quote", type: "textarea" },

	{},
	{ name: "Buying Type", description: "Select purchase or lease", obj: [{ "key": "Buying_Type", "value": "N/A", "src": null }, { "key": "Buying_Type", "value": "1-Year Lease", "src": null }, { "key": "Buying_Type", "value": "2-Year Lease", "src": null }, { "key": "Buying_Type", "value": "3-Year Lease", "src": null }, { "key": "Buying_Type", "value": "Purchase", "src": null }] },

	{},
	{ name: "Data Service", description: "Include Cellular Services", obj: [{ "key": "Data_Service", "value": "N/A", "src": null }, { "key": "Data_Service", "value": "Yes", "src": null }, { "key": "Data_Service", "value": "No", "src": null }] },
	{ name: "Data Service Custom Price", description: "Override Price of Data Services (applies to all units)", type: "tel" },
	{ name: "Data Storage", description: "CLAS/FSI services", obj: [{ "key": "Data_Storage", "value": "N/A", "src": null }, { "key": "Data_Storage", "value": "Yes", "src": null }, { "key": "Data_Storage", "value": "No", "src": null }] },
	{ name: "Data Storage Custom Price", description: "Override Price of Data Services (applies to all units)", type: "tel" },
	{ name: "Remote Guards", description: "CLAS/FSI services", obj: [{ "key": "Remote_Guards", "value": "N/A", "src": null }, { "key": "Remote_Guards", "value": "Yes", "src": null }, { "key": "Remote_Guards", "value": "No", "src": null }] },
	{ name: "Remote Guards Custom Price", description: "Override Price of Remote Guards (applies to all units)", type: "tel" },

	{},
	{ name: "Terms", description: "Terms for the quote", type: "text" },

	{},
	{ name: "Discount", description: "Amount to Discount", type: "tel" },
	{ name: "Discount Title", description: "Name of the discount", type: "text" },

	{},
	{ name: "Targeted Delivery Date", description: "Targeted delivery date", type: "date-fix", max: "10" },
	{ name: "Shipping Costs", description: "Estimated shipping costs", type: "tel" },

	{},
	{ name: "Sales Rep", description: "Sales Rep from Flex Security", type: "text" },

	{},
	{ name: "Estimated Taxes", description: "Estimated taxes for the quote", type: "tel" }

]


const CustomerSelect = props => {
	const { loadSheet } = UseGoogleSheet({ spreadsheetId: process.env.REACT_APP_FS_CUSTOMER });
	const [rows, setRows] = useState(null);
	const [value, setValue] = useState(props.value || null);

	useLayoutEffect(() => {
		loadSheet(true).then((sheets) => {
			setRows(sheets);
		});
	}, []);

	const onChange = (e, value) => {
		e.preventDefault();
		if (!value) return;

		// loadSheet(true).then((sheets) => {
		// let row = sheets?.find(row => row._rowNumber === obj.index);
		let row = rows?.find(row => row.get('Business Name') === value);

		if (row) {
			props.setValues({
				...props.values,
				"Business_Name": row.get('Business Name') || null,
				"Customer_Name": row.get('Customer Name') || null,
				"Customer_Address": row.get('Customer Address') || null,
				"Primary_Phone": row.get('Primary Phone') || null,
				"Primary_Email": row.get('Primary Email') || null,
				"Tax_Exempt": row.get('Tax Exempt') || null,
			})
			setValue(value);
		} else {
			alert("Could not locate the row")
		}
		// });
	}

	useLayoutEffect(() => {
		if (props.customer) setValue(props.customer);
	}, [props.customer]);

	return <>
		{rows && rows.length && <select disabled={props.disabled ? "disabled" : null} className="tw-min-w-50px tw-flex-grow tw-min-h-[2.625rem] !tw-border-white tw-font-code-normal tw-text-black" id={props.id || null} name={props.name || props.id || null} onChange={e => onChange(e, e.target.value)} value={props.value || ""}>
			{value ? <option value={value}>{value}</option> : <option value="">Select Customer</option>}
			{rows?.map((row, index) => {
				// return <option key={`customerSelect_${ index }`} value={ row.get('UUID') }>{ row.get('Business Name') }</option>
				return <option key={`customerSelect_${index}`} value={row.get('Business Name')}>{row.get('Business Name')}</option>
			})}
		</select>
		}
	</>
}

export default function Quote() {
	const { id } = useParams();
	const appContext = useAppContext();
	const formRef = useRef();
	const [values, setValues] = useState({});
	const [rows, setRows] = useState([]);
	const [rowsOfUnits1, setRowsOfUnits1] = useState([]);
	const [qcItems, setQcItems] = useState([]);
	const { loadSheet, sheetRows, setRow, addRow, saveRow } = UseGoogleSheet({ spreadsheetId: process.env.REACT_APP_FS_QUOTES });
	const [editMode, setEditMode] = useState(false);
	const [uuid, setUuid] = useState(null);
	const { currentUser } = useAuth();
	const navigate = useNavigate();
	const [fields, setFields] = useState(customerFormData);
	const [customer, setCustomer] = useState(null);


	const addRowToSheet = (obj, message = "Added row to sheet") => {
		return new Promise((resolve, reject) => {
			addRow(obj);
			resolve(message);
		});
	}

	const updateRowInSheet = (obj, message = "Updated row in sheet") => {
		return new Promise((resolve, reject) => {
			loadSheet(true).then((sheets) => {
				// let row = sheets?.find(row => row._rowNumber === obj.index);
				let row = sheetRows?.find(row => row.get('UUID') === obj?.UUID);

				if (row) {
					const promises = Object.keys(obj).map(key => setRow(row, key, obj[key]));
					Promise.all(promises).then(() => {
						saveRow(row);
						resolve(message);
					});
				} else {
					alert("Could not locate the row")
				}
			});
		});
	}

	const saveSuccess = (target = null, url = null) => {
		if (target) {
			setTimeout(() => {
				target?.classList.remove("_loading")
				target?.classList.add("_success");
				setTimeout(() => {
					target?.classList.remove("_success");
					setEditMode(true);

					if (url) {
						window.scrollTo(0, 0);
						window.location.href = url;
					}
				}, 1000);
			}, 750);
		}
	}

	// write a function to take ######## and convert it to ##/##/#### format
	const formatDate2 = (date) => {
		if (date.length === 8) {
			return `${date.slice(0, 2)}/${date.slice(2, 4)}/${date.slice(4, 8)}`;
		} else if (date.length === 6) {
			return `${date.slice(0, 2)}/${date.slice(2, 4)}/${date.slice(4, 6)}`;
		} else if (date.length === 4) {
			return `${date.slice(0, 2)}/${date.slice(2, 4)}`;
		} else if (date.length === 2) {
			return `${date.slice(0, 2)}`;
		} else {
			return date;
		}
	}


	const handleField = (e, type) => {
		if (type === "date-fix") {
			let temp = e.target.value?.length > 2 ? formatDate2(digitsOnly(e.target.value)) : digitsOnly(e.target.value);
			setValues((prev) => ({ ...prev, [e.target.name]: temp }));
		} else {
			const temp = e.target.value;
			setValues((prev) => ({ ...prev, [e.target.name]: temp }));
		}
	}

	const handleCheckbox = () => {
	}

	const handleSave = (e, update = editMode, callback = null) => {
		if (e) e.preventDefault();

		const target = e?.target;
		if (target) target.classList.add("_loading");

		// Construct the tempEntries object with updatedValues
		const tempEntries = update
			? {
				...values, // Use updatedValues here
				"Updated On": new Date().toISOString(),
				"Updated By": `${currentUser.userinfo ? currentUser.userinfo?.name : 'Unknown'}`,
			}
			: {
				...values, // Use updatedValues here
				"UUID": uuid,
				"Created On": new Date().toISOString(),
				"Updated On": new Date().toISOString(),
				"Created By": `${currentUser.userinfo ? currentUser.userinfo?.name : 'Unknown'}`,
				"Updated By": `${currentUser.userinfo ? currentUser.userinfo?.name : 'Unknown'}`,
			};

		const entries = removeUnderscore(tempEntries);

		if (update) {
			// Update row
			updateRowInSheet(entries, `Updated row ${JSON.stringify(entries, null, 2)} in sheet`).then((message) => {
				console.log(message);
				saveSuccess(target);

				if (callback) {
					setTimeout(() => {
						callback();
					}, 1000);
				}
			});
		} else {
			// Add new row
			addRowToSheet(entries, `Added row ${JSON.stringify(entries, null, 2)} in sheet`).then((message) => {
				console.log(message);
				saveSuccess(target);

				document.querySelector("html").classList.add("reloading");

				setTimeout(() => {
					alert("Great success!\nRedirecting to the new URL...");
					document.querySelector("html").classList.remove("reloading");
					// Redirect to the new URL
					window.location.href = `/fs/quote/${uuid}`;
					window.scrollTo(0, 0);
					if (callback) {
						setTimeout(() => {
							callback();
						}, 1000);
					}
				}, 1500);
			});
		}
	}


	const handleChange = (e, filter) => {
		if (e && filter) {
			if (filter === "phone") {
				const formattedValue = formatPhoneNumber(e.target.value.replaceAll(" ", "").replaceAll("-", "").replaceAll("(", "").replaceAll(")", ""));
				setValues((prev) => ({ ...prev, [e.target.name]: formattedValue }));
				// e.target.value = formattedValue;
			}
		}
	}

	//Loads the sheet and sets the values, otherwise creates new row (sets UUID)
	useLayoutEffect(() => {
		loadSheet(true).then((sheets) => {
			setRows(sheets);
			setRowsOfUnits1(sheets);

			if (id) {
				let row = sheets?.find(row => row.get('UUID') === id.toString());
				const tempUUID = row.get('UUID');
				const tempCustomer = row.get("Business Name");
				setUuid(tempUUID);
				setValues({
					"Business_Name": tempCustomer,
					"Customer_Address": row.get("Customer Address"),
					"Customer_Name": row.get("Customer Name"),
					"UUID": tempUUID,
					"Created_By": row.get("Created By"),
					"Created_On": row.get("Created On"),
					"Updated_By": row.get("Updated By"),
					"Updated_On": row.get("Updated On"),
					"Primary_Phone": row.get("Primary Phone"),
					"Primary_Email": row.get("Primary Email"),
					"Notes": row.get("Notes"),
					"Tax_Exempt": row.get("Tax Exempt"),
					"Alpha": row.get("Alpha"),
					"Alpha_SIGHT": row.get("Alpha SIGHT"),
					"Alpha_APEX": row.get("Alpha APEX"),
					// "Alpha_FLIGHT": row.get("Alpha FLIGHT"),
					"Bravo": row.get("Bravo"),
					"Pogo": row.get("Pogo"),
					"Data_Service": row.get("Data Service"),
					"Data_Storage": row.get("Data Storage"),
					"Remote_Guards": row.get("Remote Guards"),
					"Sales_Rep": row.get("Sales Rep"),
					"Discount": row.get("Discount"),
					"Discount_Title": row.get("Discount Title"),
					"Targeted_Delivery_Date": row.get("Targeted Delivery Date"),
					"Memo": row.get("Memo"),
					"Buying_Type": row.get("Buying Type"),
					"Terms": row.get("Terms"),
					"Shipping_Costs": row.get("Shipping Costs"),
					"Estimated_Taxes": row.get("Estimated Taxes"),
					"Data_Service_Custom_Price": row.get("Data Service Custom Price"),
					"Data_Storage_Custom_Price": row.get("Data Storage Custom Price"),
					"Remote_Guards_Custom_Price": row.get("Remote Guards Custom Price"),
					"Alpha_Custom_Price": row.get("Alpha Custom Price"),
					"Alpha_SIGHT_Custom_Price": row.get("Alpha SIGHT Custom Price"),
					"Alpha_APEX_Custom_Price": row.get("Alpha APEX Custom Price"),
					"Bravo_Custom_Price": row.get("Bravo Custom Price"),
					"Pogo_Custom_Price": row.get("Pogo Custom Price"),
					"Custom_Input_Name": row.get("Custom Input Name"),
					"Custom_Input_Description": row.get("Custom Input Description"),
					"Custom_Input_Cost": row.get("Custom Input Cost"),
					"Custom_Input_Custom_Price": row.get("Custom Input Custom Price"),
					"Custom_Input_Quantity": row.get("Custom Input Quantity"),

					"Custom_Input_2_Name": row.get("Custom Input 2 Name"),
					"Custom_Input_2_Description": row.get("Custom Input 2 Description"),
					"Custom_Input_2_Cost": row.get("Custom Input 2 Cost"),
					"Custom_Input_2_Custom_Price": row.get("Custom Input 2 Custom Price"),
					"Custom_Input_2_Quantity": row.get("Custom Input 2 Quantity"),
					"Custom_Input_3_Name": row.get("Custom Input 3 Name"),
					"Custom_Input_3_Description": row.get("Custom Input 3 Description"),
					"Custom_Input_3_Cost": row.get("Custom Input 3 Cost"),
					"Custom_Input_3_Custom_Price": row.get("Custom Input 3 Custom Price"),
					"Custom_Input_3_Quantity": row.get("Custom Input 3 Quantity"),
					"Custom_Input_4_Name": row.get("Custom Input 4 Name"),
					"Custom_Input_4_Description": row.get("Custom Input 4 Description"),
					"Custom_Input_4_Cost": row.get("Custom Input 4 Cost"),
					"Custom_Input_4_Custom_Price": row.get("Custom Input 4 Custom Price"),
					"Custom_Input_4_Quantity": row.get("Custom Input 4 Quantity"),
					"Custom_Input_5_Name": row.get("Custom Input 5 Name"),
					"Custom_Input_5_Description": row.get("Custom Input 5 Description"),
					"Custom_Input_5_Cost": row.get("Custom Input 5 Cost"),
					"Custom_Input_5_Custom_Price": row.get("Custom Input 5 Custom Price"),
					"Custom_Input_5_Quantity": row.get("Custom Input 5 Quantity"),

				});
				setCustomer(tempCustomer);
				setEditMode(true);
			} else {
				setUuid(generateUUID());
			}
		});
	}, []);

	// make handle generate quote after handleSave is completed
	const handleGenerateQuoteAfterSave = (e) => {
		setTimeout(() => {
			window.location.href = `/fs/quote/pdf/${uuid}`;
			window.scrollTo(0, 0);
		}, 3000);
	}

	return <>

		<div className="tw-w-full tw-px-40d tw-flex tw-space-x-40d">
			<form ref={formRef} className="tw-w-full tw-space-y-40px tw-pb-60px">

				{/* { editMode ? <>
					<SelectUnit editMode={ editMode} values={ values } setValues={ setValues } uuid={ values.UUID } model={ values.Model } name={ values?.["Unit Name"] } vin={ values?.VIN} qcItems={ qcItems }></SelectUnit>
				</> : <>
					<SelectUnit values={ values } setValues={ setValues } qcItems={ qcItems }></SelectUnit>
				</>} */}

				{/* { customerFormData && values?.UUID && <> */}
				<div className="tw-space-y-30px">

					<div className="tw-space-y-20px">
						<FieldsetWrapperFS title={"Quote"}>
							{customerFormData.map((item, index) => {
								const tempID = item.name?.replaceAll(" ", "_") || "";
								const isCustomPrice = item.name?.includes("Custom Price") || false;
								const isAllowedToEditPrice = currentUser?.userinfo?.name === "Anyta McVeigh" || currentUser?.userinfo?.name === "Kevin Mack" || currentUser?.userinfo?.name === "Matt Whitslar" || currentUser?.userinfo?.name === "Kevin Schwartz" || currentUser?.userinfo?.name === "Brian Carmichael";
								const hidePriceItem = isCustomPrice && !isAllowedToEditPrice;


								return hidePriceItem ? <>
								</> : item.name ? <>
									<fieldset className={`tw-flex tw-flex-col tw-w-full`}  key={`checkbox_pdi_${index}`}>
										<label htmlFor={tempID} className="tw-uppercase tw-tracking-[.1em] tw-text-[0.9em] tw-w-full tw-font-quaternary tw-flex tw-flex-col [&_>span]:tw-w-full tw-font-quaternary-normal">
											<span>
												{item.name}
											</span>
											{item.description && <span className="tw-normal-case tw-text-[.75em] tw-text-white/60">
												{item.description}
											</span>}
										</label>
										{item.obj ? <DynamicSelectorButtons values={values} setValues={setValues} value={values[tempID] || ""} id={tempID} obj={item.obj} /> : item.name === "Customer Name" ? <CustomerSelect values={values} disabled={customer || null} value={customer || values["Customer_Name"] || values["Customer Name"] || null} id="Customer Name" setValues={setValues} /> : <Field maxLength={item.max || null} type={item.type && item.type === "data-fix" ? "tel" : item.type || "text"} id={tempID} value={values[tempID] || ""} onInput={e => handleField(e, item.type || null)} onChange={e => handleChange(e, item.filter || false)} />}
									</fieldset>
								</> : <>
									<hr className="tw-border-t-1px tw-border-b-0px tw-border-x-0px tw-border-t-white/30 tw-p-0px !tw-mt-40px tw-block tw-h-20px" />
								</>
							})}
						</FieldsetWrapperFS>
						<div className="tw-w-full tw-flex tw-justify-between">
							<ButtonLight type="submit" className="tw-uppercase" default onClick={e => handleSave(e, editMode, handleGenerateQuoteAfterSave())}>
								<span className="tw-text-[1.5em] tw-py-5em tw-px-20em tw-w-full tw-flex tw-items-center tw-justify-center">
									<span>
										Generate Quote
									</span>
								</span>
							</ButtonLight>
							<ButtonLight type="submit" className="tw-uppercase" default onClick={handleSave}>
								<span className="tw-text-[1.5em] tw-py-5em tw-px-20em tw-w-full tw-flex tw-items-center tw-justify-center">
									<span>
										Save
									</span>
								</span>
							</ButtonLight>
						</div>
					</div>
				</div>
			</form>
		</div>
	</>
}


// const sampleInvoice = {
// 	companyName:"Test Company",
// 	invoiceNumber: "RVMP-2025-001",
// 	date: "04/19/2025",
// 	expiresOn: "05/01/2025",
// 	customerName: "John Smith",
// 	customerAddress: "789 Secure Lane, Columbus, OH",
// 	customerEmail: "test@text.com",
// 	phone: "(614) 555-1234",
// 	shipping: 100,
// 	taxes: 100,
// 	items: [
// 		{ description: "Alpha Security Unit", isLease: true, quantity: 2, unitPrice: 12500 },
// 		{ description: "Installation Fee", quantity: 1, unitPrice: 800 },
// 		{ description: "Monthly Monitoring (12mo)", quantity: 1, unitPrice: 3600 },
// 	]
// };
